import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type TagFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const TagFilled = forwardRef<SVGSVGElement, TagFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-3.139142 -3.521832) scale(1.487847)">
        <path d="M17.6806 4.03418C17.6556 3.43918 17.1706 2.95168 16.5731 2.92668L11.2856 2.70418C10.9031 2.68918 10.5231 2.83418 10.2506 3.10918L2.87562 10.4842C2.6007 10.7595 2.44629 11.1326 2.44629 11.5217C2.44629 11.9107 2.6007 12.2839 2.87562 12.5592L8.04812 17.7317C8.32562 18.0092 8.69312 18.1617 9.08562 18.1617C9.47812 18.1617 9.84562 18.0092 10.1231 17.7317L17.4981 10.3567C17.6331 10.2213 17.7388 10.0594 17.8084 9.88137C17.8781 9.7033 17.9104 9.51277 17.9031 9.32168L17.6806 4.03418ZM14.8506 8.37168C14.6741 8.54919 14.4641 8.68987 14.2328 8.78557C14.0015 8.88127 13.7535 8.93009 13.5031 8.92918C12.9931 8.92918 12.5156 8.73168 12.1556 8.37168C11.4131 7.62918 11.4131 6.41918 12.1556 5.67668C12.3321 5.49918 12.5421 5.3585 12.7735 5.2628C13.0048 5.16709 13.2528 5.11828 13.5031 5.11918C14.0131 5.11918 14.4906 5.31668 14.8506 5.67668C15.5931 6.41918 15.5931 7.62918 14.8506 8.37168Z" />
      </g>
    </svg>
  ),
);

TagFilled.displayName = 'TagFilled';

export default TagFilled;
